import React from "react";

import { Column, Row } from "components/Layout";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { Paper } from "components/Paper";

import { ApiModel } from "constants/loading";

import { MyAccountsTable } from "containers/Settings/Billing/Accounts/MyAccountsTable";

export const Accounts = () => {
  return (
    <WaitForSync
      requiredData={[
        ApiModel.MASTER_LEDGER_ACCOUNTS,
        ApiModel.LEDGER_ACCOUNTS,
        ApiModel.RULES,
        ApiModel.RULE_BOOKS,
      ]}
    >
      <Row flexGrow full>
        <Column margin={2} gridGap={2} full>
          <Paper square>
            <MyAccountsTable />
          </Paper>
        </Column>
      </Row>
    </WaitForSync>
  );
};
